import { Controller } from "@hotwired/stimulus"

// Pre-fills the day-picker bottom sheet with the recipe id + name when
// the trigger button is tapped. The sheet itself is opened by the
// bottom-sheet controller; this controller just hydrates the form.
//
// Wired declaratively via data-action on the sheet element rather than
// addEventListener — see .claude/rules/javascript.md.
export default class extends Controller {
  static targets = ["recipeIdInput", "recipeName"]

  hydrate(event) {
    const trigger = event.target.closest("[data-day-picker-recipe-id-param]")
    if (!trigger) return
    if (this.hasRecipeIdInputTarget) {
      this.recipeIdInputTarget.value = trigger.dataset.dayPickerRecipeIdParam
    }
    if (this.hasRecipeNameTarget) {
      this.recipeNameTarget.textContent = trigger.dataset.dayPickerRecipeNameParam || ""
    }
  }
}
